import {useEffect, useState} from 'react';
import { Navigate } from 'react-router-dom';
import {supabase} from '../services/supabaseClient';

const isSessionValid = (session) => {
  if (!session) return false;

  // Check if session has expired
  if (session.expires_at) {
    const expiresAtMs = session.expires_at * 1000; // Convert to milliseconds
    const now = Date.now();
    if (now > expiresAtMs) {
      console.log("DEBUG: session has expired");
      return false;
    }
  }

  return true;
};

const ProtectedRoute = ({ children }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    // Check current session
    supabase.auth.getSession().then(({ data: { session } }) => {
      console.log("DEBUG: session expires at:", session?.expires_at);
      setSession(isSessionValid(session) ? session : null);
      setLoading(false);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(isSessionValid(session) ? session : null);
      setLoading(false);
    });
    
    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;